// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7ef4fd3","455":"1a8d7d4a","977":"2b9f3fa6"}[chunkId] + ".chunk.js";
};